import { GetScrapFinanceTradesHistoryApi } from "@/features/accounts/scrap-finance/services/get-trades-history-api";
import { GetScrapFinanceTradesHistoryRequestModel } from "@/features/accounts/scrap-finance/services/get-trades-history-model";

/// 銀行取込履歴取得処理
export class GetScrapFinanceTradesHistoryService {
  private getScrapFinanceTradesHistoryApi = new GetScrapFinanceTradesHistoryApi();

  /**
   * 銀行取込履歴取得API実行
   */
  public async getScrapFinanceTradesHistory(param: GetScrapFinanceTradesHistoryRequestModel) {
    return await this.getScrapFinanceTradesHistoryApi.getScrapFinanceTradesHistory(param);
  }
}
